module.exports = __webpack_public_path__ + "cee3b77007cf333d40311410af0f66ad.svg";